import { render } from "./buildingEdit.vue?vue&type=template&id=727b53da&scoped=true"
import script from "./buildingEdit.vue?vue&type=script&lang=js"
export * from "./buildingEdit.vue?vue&type=script&lang=js"

import "./buildingEdit.vue?vue&type=style&index=0&id=727b53da&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727b53da"]])

export default __exports__